(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var marquee = document.querySelector('[data-banner-marquee]');
    if (!marquee) return;

    // Calculate animation duration based on content width
    // Divide by 25 since we render 25 copies for seamless infinite loop
    var contentWidth = marquee.scrollWidth / 25;
    var duration = Math.max(contentWidth / 50, 50); // 50px per second, minimum 20s

    marquee.style.setProperty('--marquee-duration', duration + 's');
  })();

  // Bottom banner mobile rotation
  (function () {
    var bottomBannerWrapper = document.querySelector('[data-bottom-banner-wrapper]');
    if (!bottomBannerWrapper) return;

    var items = bottomBannerWrapper.querySelectorAll('.bottom-banner-item');
    if (items.length <= 1) return; // Nothing to rotate if only one item

    var currentIndex = 0;
    var isMobile = window.innerWidth < 768;
    var interval = null;

    function showItem(index) {
      items.forEach(function (item, i) {
        if (i === index) {
          item.classList.add('active');
          item.classList.remove('hidden');
        } else {
          item.classList.remove('active');
          if (isMobile) {
            item.classList.add('hidden');
          }
        }
      });
    }

    function nextItem() {
      if (!isMobile) return;
      currentIndex = (currentIndex + 1) % items.length;
      showItem(currentIndex);
    }

    function startRotation() {
      if (interval) clearInterval(interval);
      if (isMobile && items.length > 1) {
        interval = setInterval(nextItem, 3000);
      }
    }

    function stopRotation() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    function handleResize() {
      var wasMobile = isMobile;
      isMobile = window.innerWidth < 768;

      if (wasMobile !== isMobile) {
        stopRotation();
        if (isMobile) {
          showItem(currentIndex);
          startRotation();
        } else {
          // Show all items on desktop
          items.forEach(function (item) {
            item.classList.remove('hidden', 'active');
          });
        }
      }
    }

    // Initialize
    if (isMobile) {
      showItem(0);
      startRotation();
    }

    // Handle window resize
    window.addEventListener('resize', handleResize);

    // Pause on hover (if needed)
    bottomBannerWrapper.addEventListener('mouseenter', stopRotation);
    bottomBannerWrapper.addEventListener('mouseleave', function () {
      if (isMobile) startRotation();
    });
  })();

  // Header mega menu toggle - handles multiple menus
  (function () {
    var triggers = document.querySelectorAll('[data-menu-trigger]');
    if (!triggers.length) return;

    var activeMenu = null;

    function openPanel(trigger, panel) {
      // Close any currently open menu
      if (activeMenu && activeMenu !== panel) {
        closePanel(activeMenu);
      }

      panel.hidden = false;
      panel.classList.remove('opacity-0', 'pointer-events-none');
      panel.classList.add('opacity-100');
      trigger.setAttribute('aria-expanded', 'true');
      activeMenu = panel;

      // focus first menuitem if available
      var first = panel.querySelector('[role="menuitem"]');
      if (first) first.focus({ preventScroll: true });

      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onKeyDown);
    }

    function closePanel(panel) {
      if (!panel) return;

      var trigger = document.querySelector(`[aria-controls="${panel.id}"]`);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      panel.classList.add('opacity-0', 'pointer-events-none');
      panel.classList.remove('opacity-100');

      // Use timeout to allow transition (if any) before hiding from a11y tree
      setTimeout(function () {
        panel.hidden = true;
      }, 180);

      if (activeMenu === panel) {
        activeMenu = null;
      }

      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onKeyDown);
    }

    function togglePanel(trigger, panel) {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        closePanel(panel);
      } else {
        openPanel(trigger, panel);
      }
    }

    function onDocumentClick(e) {
      // Check if click is outside any menu
      var clickedInsideMenu = false;
      triggers.forEach(function (trigger) {
        var panel = document.querySelector(`[data-menu-panel="${trigger.dataset.menuTrigger}"]`);
        if (trigger.contains(e.target) || (panel && panel.contains(e.target))) {
          clickedInsideMenu = true;
        }
      });

      if (!clickedInsideMenu && activeMenu) {
        closePanel(activeMenu);
      }
    }

    function onKeyDown(e) {
      if (e.key === 'Escape' && activeMenu) {
        var trigger = document.querySelector(`[aria-controls="${activeMenu.id}"]`);
        closePanel(activeMenu);
        if (trigger) trigger.focus();
      }
    }

    // Add event listeners to each trigger
    triggers.forEach(function (trigger) {
      var panel = document.querySelector(`[data-menu-panel="${trigger.dataset.menuTrigger}"]`);
      if (!panel) return;

      var closeTimeout = null;
      var isHovering = false;

      // Click handler (for accessibility and touch devices)
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        togglePanel(trigger, panel);
      });

      // Open on hover
      trigger.addEventListener('mouseenter', function () {
        isHovering = true;
        // Clear any pending close timeout
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
        openPanel(trigger, panel);
      });

      // Close when leaving trigger (with small delay to allow moving to panel)
      trigger.addEventListener('mouseleave', function (e) {
        isHovering = false;
        // Check if mouse is moving to the panel
        var relatedTarget = e.relatedTarget;
        if (relatedTarget && panel.contains(relatedTarget)) {
          return; // Mouse is moving to panel, don't close
        }
        closeTimeout = setTimeout(function () {
          if (!isHovering) {
            closePanel(panel);
          }
        }, 150);
      });

      // Keep panel open when hovering over it
      if (panel) {
        panel.addEventListener('mouseenter', function () {
          isHovering = true;
          // Clear any pending close timeout
          if (closeTimeout) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
          }
        });

        panel.addEventListener('mouseleave', function (e) {
          isHovering = false;
          // Check if mouse is moving to the trigger
          var relatedTarget = e.relatedTarget;
          if (relatedTarget && trigger.contains(relatedTarget)) {
            return; // Mouse is moving to trigger, don't close
          }
          closeTimeout = setTimeout(function () {
            if (!isHovering) {
              closePanel(panel);
            }
          }, 150);
        });
      }
    });
  })();

  // Collapsible submenu functionality with accordion behavior
  (function () {
    var collapseTriggers = document.querySelectorAll('[data-collapse-trigger]');
    if (!collapseTriggers.length) return;

    // Function to collapse a specific submenu
    function collapseSubmenu(trigger, panel, chevron) {
      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';
      trigger.setAttribute('aria-expanded', 'false');
      if (chevron) {
        chevron.style.transform = 'rotate(0deg)';
      }
    }

    // Function to expand a specific submenu
    function expandSubmenu(trigger, panel, chevron) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.style.opacity = '1';
      trigger.setAttribute('aria-expanded', 'true');
      if (chevron) {
        chevron.style.transform = 'rotate(180deg)';
      }
    }

    // Function to close all submenus
    function closeAllSubmenus() {
      collapseTriggers.forEach(function (trigger) {
        var panel = document.querySelector(`[data-collapse-panel="${trigger.dataset.collapseTrigger}"]`);
        var chevron = trigger.querySelector('.chevron-icon');

        if (panel && trigger.getAttribute('aria-expanded') === 'true') {
          collapseSubmenu(trigger, panel, chevron);
        }
      });
    }

    collapseTriggers.forEach(function (trigger) {
      var panel = document.querySelector(`[data-collapse-panel="${trigger.dataset.collapseTrigger}"]`);
      var chevron = trigger.querySelector('.chevron-icon');

      if (!panel) return;

      var closeTimeout = null;
      var isHovering = false;

      // Click handler (for accessibility and touch devices)
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          // Collapse current submenu
          collapseSubmenu(trigger, panel, chevron);
        } else {
          // Close all other submenus first
          closeAllSubmenus();

          // Expand current submenu
          expandSubmenu(trigger, panel, chevron);
        }
      });

      // Open on hover
      trigger.addEventListener('mouseenter', function () {
        isHovering = true;
        // Clear any pending close timeout
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
        // Close all other submenus first
        closeAllSubmenus();
        // Expand current submenu
        expandSubmenu(trigger, panel, chevron);
      });

      // Close when leaving trigger (with small delay to allow moving to panel)
      trigger.addEventListener('mouseleave', function (e) {
        isHovering = false;
        // Check if mouse is moving to the panel
        var relatedTarget = e.relatedTarget;
        if (relatedTarget && panel.contains(relatedTarget)) {
          return; // Mouse is moving to panel, don't close
        }
        closeTimeout = setTimeout(function () {
          if (!isHovering) {
            collapseSubmenu(trigger, panel, chevron);
          }
        }, 150);
      });

      // Keep panel open when hovering over it
      panel.addEventListener('mouseenter', function () {
        isHovering = true;
        // Clear any pending close timeout
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
      });

      panel.addEventListener('mouseleave', function (e) {
        isHovering = false;
        // Check if mouse is moving to the trigger
        var relatedTarget = e.relatedTarget;
        if (relatedTarget && trigger.contains(relatedTarget)) {
          return; // Mouse is moving to trigger, don't close
        }
        closeTimeout = setTimeout(function () {
          if (!isHovering) {
            collapseSubmenu(trigger, panel, chevron);
          }
        }, 150);
      });
    });
  })();

  // Mobile menu functionality with level-based navigation
  (function () {
    var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
    var mobileOverlay = document.querySelector('[data-mobile-menu-overlay]');
    var mobilePanel = document.querySelector('[data-mobile-menu-panel]');
    var mobileClose = document.querySelector('[data-mobile-menu-close]');
    var mobileCloseLinks = document.querySelectorAll('[data-mobile-menu-close-link]');
    var mobileBackBtns = document.querySelectorAll('[data-mobile-back]');
    var mobileMainHeader = document.querySelector('.mobile-menu-main-header');

    if (!mobileToggle || !mobileOverlay || !mobilePanel) return;

    var currentLevel = 'main';
    var levelHistory = ['main'];

    function openMobileMenu() {
      mobileToggle.classList.add('active');
      mobileToggle.setAttribute('aria-expanded', 'true');
      mobileOverlay.classList.add('active');
      mobilePanel.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Reset to main level
      showLevel('main');
    }

    function closeMobileMenu() {
      mobileToggle.classList.remove('active');
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileOverlay.classList.remove('active');
      mobilePanel.classList.remove('active');
      document.body.style.overflow = '';

      // Reset to main level
      showLevel('main');
      levelHistory = ['main'];
    }

    function showLevel(levelId) {
      var allLevels = document.querySelectorAll('[data-mobile-level]');
      var targetLevel = document.querySelector('[data-mobile-level="' + levelId + '"]');

      if (!targetLevel) return;

      // Hide all levels
      allLevels.forEach(function (level) {
        level.classList.remove('active');
        level.style.display = 'none';
      });

      // Show target level
      targetLevel.style.display = 'block';
      setTimeout(function () {
        targetLevel.classList.add('active');
      }, 10);

      // Show/hide main header based on level
      if (mobileMainHeader) {
        if (levelId === 'main') {
          mobileMainHeader.classList.remove('hidden');
        } else {
          mobileMainHeader.classList.add('hidden');
        }
      }

      currentLevel = levelId;
    }

    function navigateToLevel(levelId) {
      levelHistory.push(currentLevel);
      showLevel(levelId);
    }

    function navigateBack() {
      if (levelHistory.length > 1) {
        levelHistory.pop(); // Remove current level
        var previousLevel = levelHistory[levelHistory.length - 1];
        showLevel(previousLevel);
      } else {
        showLevel('main');
      }
    }

    // Toggle mobile menu
    mobileToggle.addEventListener('click', function () {
      if (mobileToggle.getAttribute('aria-expanded') === 'true') {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    // Close mobile menu
    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileMenu);
    }

    // Close on overlay click
    mobileOverlay.addEventListener('click', function (e) {
      if (e.target === mobileOverlay) {
        closeMobileMenu();
      }
    });

    // Close on link click
    mobileCloseLinks.forEach(function (link) {
      link.addEventListener('click', closeMobileMenu);
    });

    // Close on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileOverlay.classList.contains('active')) {
        if (currentLevel !== 'main') {
          navigateBack();
        } else {
          closeMobileMenu();
        }
      }
    });

    // Back button functionality
    mobileBackBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        navigateBack();
      });
    });

    // Main menu triggers (navigate to submenu)
    var mobileMenuTriggers = document.querySelectorAll('[data-mobile-menu-trigger]');
    mobileMenuTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var levelId = 'submenu-' + trigger.dataset.mobileMenuTrigger;
        navigateToLevel(levelId);
      });
    });

    // Submenu triggers (navigate to sub-submenu)
    var mobileSubmenuTriggers = document.querySelectorAll('[data-mobile-submenu-trigger]');
    mobileSubmenuTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var levelId = 'subsubmenu-' + trigger.dataset.mobileSubmenuTrigger;
        navigateToLevel(levelId);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
